import axios from '@axios'

const PREFIX = '/certificados'

export default {

  getCertificados(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },
  getAllEmpresas() {
    return axios.get(`${PREFIX}/empresas`)
  },
  validaCertificado(form) {
    return axios.post(`${PREFIX}/valida-certificado`, form)
  },
  GetCertificadoBy(id) {
    return axios.get(`${PREFIX}/${id}`)
  },
  getDadosTabelaVinculo(modelo) {
    return axios.get(`${PREFIX}/A3/${modelo}`)
  },
  createCertficado(certficado) {
    return axios.post(`${PREFIX}/add`, certficado)
  },
  delete(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },
  update(id, certficado) {
    return axios.put(`${PREFIX}/${id}`, certficado)
  },
  updateObservacao(id, observacao) {
    return axios.put(`${PREFIX}/${id}/observacao`, observacao)
  },
  getCertificadoByEmpresaId(empresaId, ocultar) {
    return axios.get(`${PREFIX}/empresa/${empresaId}?ocultar=${ocultar}`)
  },
  getCertificadoBySocioId(socioId, ocultar) {
    return axios.get(`${PREFIX}/socio/${socioId}?ocultar=${ocultar}`)
  },
  getEmpresasPorCertificado(id, filtro) {
    return axios.post(`${PREFIX}/${id}/empresas-socios?`, filtro)
  },
  addHistorico(id, tela) {
    return axios.post(`${PREFIX}/${id}/historico?tela=${tela}`)
  },
  getHistoricos(id) {
    return axios.get(`${PREFIX}/${id}/historico`)
  },
  getCertficadosDispensar(certficado) {
    return axios.post(`${PREFIX}/dispensa`, certficado)
  },
  exportarRelatorio(filtros) {
    return axios.post(`${PREFIX}/relatorio`, filtros)
  },
  deleteUpload(nomeArquivo) {
    return axios.delete(`${PREFIX}/delete-upload?arquivo=${nomeArquivo}`)
  },
}
